import Swal from 'sweetalert2';

function syntaxHighlightJson(obj) {
  const json = JSON.stringify(obj, null, 2);
  return json.replace(
    /("(\\u[\dA-Fa-f]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
    (match) => {
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          return `<span style="color:#0550ae">${match}</span>`;
        }
        return `<span style="color:#0a3069">${match}</span>`;
      }
      if (/true|false/.test(match)) {
        return `<span style="color:#116329">${match}</span>`;
      }
      if (/null/.test(match)) {
        return `<span style="color:#cf222e">${match}</span>`;
      }
      return `<span style="color:#953800">${match}</span>`;
    }
  );
}

const PRE_STYLE = `
  background:#f6f8fa;
  padding:16px;
  border-radius:6px;
  overflow:auto;
  font-size:12.5px;
  max-height:480px;
  line-height:1.7;
  border:1px solid #d0d7de;
  font-family:'SFMono-Regular',Consolas,'Liberation Mono',Menlo,monospace;
  margin:0;
  white-space:pre-wrap;
  word-break:break-word;
  color:#24292f;
`;

function buildLogHtml(log) {
  if (log === null || log === undefined) {
    return `<div style="text-align:left;color:#57606a;padding:16px">Sem logs disponíveis para este erro.</div>`;
  }

  if (typeof log === 'string') {
    try {
      const parsed = JSON.parse(log);
      return buildLogHtml(parsed);
    } catch (_) {
      // not valid JSON, render as plain text
    }
    return `
      <div style="text-align:left">
        <pre style="${PRE_STYLE}">${log}</pre>
      </div>
    `;
  }

  const highlighted = syntaxHighlightJson(log);
  return `
    <div style="text-align:left">
      <div style="
        display:flex;
        align-items:center;
        gap:8px;
        margin-bottom:8px;
        padding-bottom:8px;
        border-bottom:1px solid #d0d7de;
      ">
        <span style="
          background:#cf222e;
          color:#fff;
          font-size:11px;
          font-weight:600;
          padding:2px 8px;
          border-radius:12px;
          letter-spacing:.5px;
          text-transform:uppercase;
        ">${log.level || 'log'}</span>
        <span style="color:#57606a;font-size:12px">${log.service || ''}</span>
        <span style="color:#57606a;font-size:12px;margin-left:auto">${log.timestamp || ''}</span>
      </div>
      <pre style="${PRE_STYLE}">${highlighted}</pre>
    </div>
  `;
}

export function showErrorLogModal(errorLog) {
  Swal.fire({
    title: 'Logs de erro',
    html: buildLogHtml(errorLog),
    width: 'min(92vw, 960px)',
    confirmButtonText: 'Fechar',
  });
}
